import createSelect from './createSelect'

export default createSelect({
    options: [{ value: '', label: 'Всі' }, { value: true, label: 'Так' }, { value: false, label: 'Ні' }],
    placeholder: 'Всі'
})